/* eslint-disable max-len */
export default {
  add: 'Adicionar',
  aboutUs: 'Sobre nós',
  accessRequest: 'Solicitação de Acesso',
  accountInformation: 'Informações da Conta',
  activeDocuments: 'Documentos Ativos',
  addCard: 'Adicionar um novo cartão',
  address: 'Endereço',
  address2: 'Endereço:',
  addressToSend: 'Endereço de envio',
  agreement: 'Acordo',
  approve: 'Aprovar',
  approveCart: 'Aprovar Carrinho',
  approveCarts: 'Aprovar Carrinhos Selecionados',
  approveCartConfirm: 'Realmente deseja aprovar o carrinho?',
  approveCartsInfo1: 'Para aprovação em massa será utilizada a Forma de Pagamento "Faturamento" para todos os carrinhos.',
  approveCartsConfirm: 'Realmente deseja aprovar todos os carrinhos selecionados?',
  approved: 'Aprovado',
  available: 'Disponível',
  availability: 'Disponibilidade:',
  authorized: 'Autorizado',
  all: 'Todos',
  allProducts: 'Todos os Produtos',
  allCategories: 'Todas Categorias',
  bank: 'Banco',
  bankSlip: 'Boleto',
  bankSlipText1: 'Imprima o boleto e pague no banco',
  bankSlipText2: 'ou pague pela internet utilizando o código de barras do boleto',
  bankSlipText3: 'O prazo de validade do boleto é de 2 dias úteis',
  bankSlipText4: 'Para pagamento via boleto há uma taxa de R$1,00 que será acrescentada no valor total de sua compra',
  bankSlipVisualize: 'Clique para visualizar o boleto',
  beingPrepared: 'Pedido sendo preparado',
  before: 'Anterior',
  billing: 'Faturar',
  billing2: 'Faturamento',
  billed: 'Quantidade faturada:',
  birthday: 'Data de Aniversário:',
  brands: 'Marcas',
  buyDate: 'Data da compra',
  buyDate2: 'Data da compra:',
  buySolicitation: 'Solicitar Compra',
  buyInWhatsapp: 'Compre pelo Whatsapp',
  buyPerCategory: 'Comprar por categoria',
  business: 'Ramo de Atividade',
  cancel: 'Cancelar',
  canceled: 'Cancelado',
  categories: 'Categorias',
  cardInvalid: 'Cartão inválido, aceitamos apenas Visa, Master Card e Elo.',
  cardName: 'Nome Impresso no cartão',
  cardNumber: 'Número do cartão',
  cardNumberInvalid: 'Número do cartão inválido',
  cart: 'Carrinho',
  cartEmpty: 'Carrinho vazio',
  cartSolicitationText: 'Sua requisição foi enviada para um aprovador da sua empresa. Este pedido só será finalizado e válido após a aprovação do(s) responsável(eis).',
  cartSolicitationText2: 'Atenção:',
  cartSolicitationText3: 'O prazo de entrega só começa a contar depois que o aprovador de alçada aprovar esta requisição de compra.',
  cartEstimateText: 'Sua solicitação de orçamento foi enviada.',
  cartChanged: 'Atenção... Os itens do seu carrinho foram alterados,'
    + 'por favor confira os itens antes de finalizar o pedido.',
  cartToApprove: 'Carrinhos para aprovar:',
  cartToApproveTwo: 'Carrinhos para aprovar',
  cartProducts: 'produtos no carrinho',
  cartBags: 'Produtos na sacola',
  cartOrderByDateAsc: 'Ordenar por Data de Inserção Crescente',
  cartOrderByDateDesc: 'Ordenar por Data de Inserção Decrescente',
  cartOrderByNameAsc: 'Ordenar por Nome Crescente',
  cartOrderByNameDesc: 'Ordenar por Nome Decrescente',
  orderBy: 'Ordernar por',
  cartFreight: 'Frete Entrega',
  cartFreightPac: 'Normal PAC',
  cartFree: 'Grátis',
  cartCoupon: 'Cupom de Desconto',
  cartCouponApplied: 'Cupom aplicado',
  cartTotalToPay: 'Total a pagar',
  cartName: 'Carrinho de compras',
  cartStatus: 'Status do Carrinho: #',
  pendingApproval: 'Pendente de Aprovação',
  captured: 'Efetivado',
  currentCartWillChange: 'Seu carrinho atual será substituído, deseja continuar?',
  city: 'Cidade',
  cityAndState: 'Cidade e Estado:',
  change: 'Alterar',
  changeAddress: 'Alterar Entrega',
  changePayment: 'Alterar pagamento',
  changePasswordIsNotPossible: 'Não é possível alterar a senha, você não solicitou uma recuperação de senha.',
  company: 'Empresa',
  companyName: 'Razão Social',
  companyData: 'Dados da Empresa',
  complement: 'Complemento',
  contact: 'Entre em contato',
  contactData: 'Dados do Contato',
  contactUs: 'Fale Conosco',
  continueBuy: 'Continuar Comprando',
  confirm: 'Confirmar',
  confirmed: 'Confirmado',
  confirmPassword: 'Confirmar Senha',
  confirmNewPassword: 'Confirmar nova senha',
  contract: 'Contrato',
  contracts: 'Contratos',
  contractNotFound: 'Desculpe, nenhum contrado encontrado.',
  contractProducts: 'Produtos de Contrato',
  contractSelect: 'Selecione o contrato',
  contractSelectDown: 'desejado abaixo.',
  consultUs: 'Consulte-nos',
  consultUsTime: 'Prazo: CONSULTE-NOS',
  consumption: 'Uso Consumo',
  copyOrder: 'Copiar Pedido',
  cancelOrder: 'Cancelar Pedido',
  cancellationOrder: 'Cancelamento do Pedido',
  cancelOrderConfirm: 'Realmente deseja cancelar este pedido?',
  country: 'País',
  country2: 'País:',
  csv: 'CSV',
  checkout: 'Checkout',
  checkoutContact: 'Nossa equipe receberá os produtos requesitados e entrará em contato com os preços.',
  checkoutDeliveryHeader: 'Tipo de entrega',
  checkoutDeliveryHeaderTwo: 'Tipo de entrega:',
  checkoutDeliverySubHeader: 'Endereços de Entrega',
  checkoutSelectFreigth: 'Selecione o frete',
  credit: 'Crédito',
  crossSelling: 'Cross Selling',
  crossSellingProduct: 'Produtos em destaque',
  cleanCart: 'Limpar Carrinho',
  cleanFilters: 'Limpar filtros',
  clear: 'Limpar',
  clientCode: 'Código do Cliente:',
  clientCode2: 'Código Cliente:',
  clientItemCode: 'Código Item Cliente:',
  clientDescription: 'Descrição do Cliente',
  code: 'Código: #',
  code2: 'Código:',
  codeSphere: 'Código Pedido Interno:',
  codeSphere2: '| Código Pedido Interno:',
  codeSolicitation: 'Código da Solicitação:',
  close: 'Fechar',
  cnpj: 'CNPJ',
  cpf: 'CPF',
  cep: 'CEP',
  cep2: 'CEP:',
  currentPassword: 'Senha atual',
  cvv: 'CVV',
  cvvInvalid: 'CVV inválido',
  days: 'Dias',
  discount: 'Desconto',
  description: 'Descrição',
  debitOn: 'Débito Online',
  debit: 'Débito',
  decline: 'Reprovar',
  declineCart: 'Reprovar Carrinho',
  declineCarts: 'Reprovar Carrinhos Selecionados',
  declineCartConfirm: 'Realmente deseja reprovar o carrinho?',
  declineCartsConfirm: 'Realmente deseja reprovar todos os carrinhos selecionados?',
  deleteCard: 'Excluir Cartão',
  delivered: 'Pedido entregue',
  delivered2: 'Entregue',
  deliveryAllCountry: 'Entrega em todo o Brasil',
  deliveryAllCountryText: 'Temos a estrutura necessária para te atender da melhor forma, onde quer que você esteja.',
  details: 'Ver Detalhes do Pedido',
  details2: 'Detalhes',
  deliveryType: 'TIPO DE ENTREGA',
  delivery: 'Entrega',
  defaultAddress: 'Endereço padrão',
  discoverCategory: 'Conheça as categorias',
  didYouMean: 'Você quis dizer?',
  district: 'Bairro',
  downloadApp: 'Baixe grátis o App!',
  downloadPdf: 'BAIXAR  PDF',
  documentList: 'Pedidos e orçamentos realizados:',
  documentList2: 'Pedidos e Orçamentos',
  documentStatus: 'Status do Pedido',
  documentStatus2: '| Status do Pedido:',
  documentStatus3: 'Status do Pedido:',
  emailCnpjMessage: 'E-mail já cadastrado com esse CNPJ',
  emailCnpjMessage2: 'E-mail não relacionado com esse CNPJ',
  emailCnpjMessage3: 'Cliente não cadastrado com esse CNPJ',
  emailCnpjMessage4: 'E-mail e/ou CNPJ/CPF já cadastrados!',
  emailRecoverSuccess: 'Verifique sua caixa de entrada, enviaremos um email com a sua nova senha de acesso',
  emailRecoverError: 'E-mail inválido, verifique seu e-mail ou tente mais tarde',
  entry: 'Entrar',
  error: 'ERRO!',
  errorOcurred: 'Desculpe ocorreu um erro',
  errorOcurred2: 'Desculpe, ocorreu um erro.',
  errorTryLater: 'Ocorreu um erro, tente mais tarde.',
  email: 'E-mail',
  emailCnpj: 'E-mail/CNPJ',
  emailCnpjCpf: 'E-mail/Documento',
  emailPlaceholder: 'Digite o seu e-mail',
  errorNewRegister: 'Cadastro solicitado com sucesso!',
  errorNewRegisterText: 'Enviaremos um e-mail assim que seu cadastro estiver ativado.',
  errorPasswordPolicy: 'Senha inválida. Verifique se a senha informada atende a política de senha.',
  estimate: 'Orçamento',
  estimateSolicitation: 'Pedir um Orçamento',
  estimateTime: 'Prazo de Entrega',
  especification: 'Especificações:',
  expirationDateInvalid: 'Data de expiração inválida',
  expirationMonthInvalid: 'Mês de de expiração inválida, entre (01 e 12)',
  expirationYearInvalid: 'Ano de expiração inválido',
  expirationPlaceholder: 'MM/AA',
  exit: 'Sair',
  features: 'Características',
  finalize: 'Finalizar',
  finalize2: 'Finaliza',
  finalizeIn: 'Finaliza em',
  finalized: 'Finalizado',
  finalizeBuy: 'Finalizar Compra',
  finalizeOrder: 'Finalizar Pedido',
  firstName: 'Primeiro Nome',
  fileGenerate: 'Gerar Arquivo',
  flagInvalid: 'Bandeira não aceita',
  forgotPassword: 'Esqueceu sua senha? Digite seu email.',
  forgotPassword2: 'Esqueceu a senha',
  footerWhere: 'Onde estamos',
  footerAttendance: 'Atendimento',
  footerConsumer: 'ao consumidor',
  footerInstitute: 'Institucional',
  footerMyPurchases: 'Meu Painel',
  footerAppToBuy: 'Compre pelo app',
  footerAppStore: 'Disponível na App Store',
  footerPlayStore: 'Disponível na Google Play',
  footerPayments: 'Pagamentos aceitos',
  generateSummary: 'Gerar Relatório de Pedidos',
  generateContract: 'Gerar Relatório Produtos de Contrato',
  general: 'Geral',
  hasIe: 'Possui Inscrição Estadual?',
  home: 'Início',
  howWorks: 'Como Funciona',
  icmsDiferido: 'ICMS Diferido',
  icmsIsento: 'ICMS Isento',
  immediateTime: 'Prazo Máximo: IMEDIATA',
  industrialization: 'Industrialização',
  insertNewPassword: 'Digite sua nova senha.',
  inTransport: 'Em transporte',
  insertEmail: 'Digite o seu e-mail',
  insertCnpj: 'Digite o seu CNPJ',
  insertCpf: 'Digite o seu CPF',
  invalidEmail: 'E-mail inválido',
  invalidCNPJ: 'CNPJ inválido',
  invalidCPF: 'CPF inválido',
  invalidCep: 'CEP inválido!',
  invalidAmount: 'QUANTIDADE ADICIONADA INDISPONÍVEL EM ESTOQUE',
  invalidAmount2: 'Quantidade adicionada não possui disponibilidade em estoque, o item possui ',
  invalidAmount3: 'em estoque. Caso queira uma quantidade maior verifique a disponibilidade com o nosso televendas: ',
  invalidLogin: 'E-mail ou senha inválidos',
  invoiceIssued: 'Faturado',
  invoiceIssuedPartially: 'Parcialmente Faturado',
  installmentsNumber: 'Número de parcelas:',
  installments: 'Parcelas',
  ipi: 'IPI',
  items: 'Itens',
  json: 'JSON',
  job: 'Cargo',
  lastName: 'Sobrenome',
  birthDate: 'Data de Nascimento (Opcional)',
  birthDate2: 'Data de Nascimento',
  punchOut: 'Punch Out',
  punchOutTitle: 'ENTRAR via Punch Out',
  punchOutText: 'fazendo login via punch out',
  buyPunchOut: 'Finalizar Punch Out',
  limitCartWarning: 'Usuário sem permissão para ver esse carrinho',
  loading: 'Carregando...',
  login: 'Login',
  loginForgotPassword: 'Esqueceu a senha?',
  loginButton: 'ENTRAR',
  loginText: 'Se você já tem uma conta conosco, faça o login.',
  loginTitle: 'ENTRAR',
  loginRegisterSolicitation: 'Solicite um Cadastro',
  loginNewRegister: 'Cadastro',
  loginNewRegisterCnpjCpf: 'CNPJ ou CPF',
  loginNewRegisterConfirmPw: 'Confirme sua senha',
  loginNewRegisterData: 'Dados',
  loginNewRegisterDataBusiness: 'Dados da empresa',
  loginNewRegisterPlaceCnpjCpf: 'Digite o CNPJ ou CPF',
  loginNewRegisterPlaceCnpj: 'Digite o CNPJ',
  loginNewRegisterPlaceCep: 'Digite o CEP',
  loginNewRegisterPlaceStreet: 'Digite a rua',
  loginNewRegisterPlaceNumber: 'Digite o número',
  loginNewRegisterPlaceComplement: 'Digite o complemento',
  loginNewRegisterPlaceDistrict: 'Digite o bairro',
  loginNewRegisterPlaceSelectRole: 'Selecione um cargo',
  loginNewRegisterPlaceSelectSector: 'Selecione um setor',
  loginNewRegisterPlaceSelectPhone: 'Digite o telefone',
  loginNewRegisterPlaceFirstName: 'Digite o primeiro nome',
  loginNewRegisterPlaceLastName: 'Digite o sobrenome',
  loginNewRegisterPlaceCompanyName: 'Digite a razão social',
  loginNewRegisterPlaceSelectPurpose: 'Selecione uma finalidade',
  loginNewRegisterPlaceSelectBusiness: 'Selecione um ramo de atividade',
  loginNewRegisterCheckInsSta: 'Possui Inscrição estadual? (inserir sem pontuação)',
  loginNewRegisterFinalize: 'Finalizar cadastro',
  loginCadNew: 'Cadastre-se',
  loginError: 'ERRO!',
  loginIdentify: 'Identifique-se para continuar',
  loginInfoEmail: 'Digite seu e-mail abaixo para finalizar a sua compra.',
  markAll: 'Marcar Todos',
  maxTime: 'Prazo Máximo:',
  mySolicitations: 'Minhas solicitações:',
  mySolicitations2: 'Minhas solicitações',
  minimumOf: 'Mínimo de',
  minimumPayment: 'Mínimo de R$',
  minimumPayment2: 'para finalizar a compra',
  myInformations: 'Minhas Informações',
  myAccount: 'Minha Conta',
  minutes: 'minutos',
  name: 'Nome',
  name2: 'Nome:',
  naoContribIcms: 'Não Contribuinte do ICMS',
  needHelp: 'Precisa de ajuda?',
  needHelpText: 'Nosso pós-vendas estará sempre à disposição para esclarecer dúvidas sobre seu pedido.',
  navigation: 'Navegação',
  newPassword: 'Nova senha',
  next: 'Próximo',
  newApp: 'Novo App para uma experiência única.',
  notAuthorized: 'Não autorizado',
  noneDocument: 'Nenhum pedido/orçamento realizado.',
  noLimit: 'Não foi possível finalizar a compra. Por favor entre em contato com o administrador de '
    + 'seu contrato/conta para consultar o saldo disponível.',
  normalDelivery: 'Entrega normal',
  number: 'Número',
  obsIe: 'Inserir sem pontuação',
  observationText: 'Adicionar observações na nota fiscal',
  observationTextNortel: 'Adicionar observações na nota fiscal (limite 75 caracteres)',
  pageNotFound: 'Página não encontrada!',
  panel: 'Meu Painel',
  password: 'Senha',
  passwordDifferents: 'As senhas são diferentes.',
  passwordPlaceholder: 'Digite a sua senha',
  passwordPlaceholder2: 'Confirme a sua senha',
  passwordErrorMessage: 'A senha atual deve ser maior ou igual a 6 caracteres e menor que 50.',
  passwordErrorMessage2: 'A senha deve ser maior ou igual a ',
  passwordErrorMessage3: ' caracteres e menor que ',
  passworderrorMessage: 'A senha informada não atende a política de senha',
  passwordErrorMinChar: 'A senha deve conter no mínimo 9 caracteres',
  passwordErrorNumber: 'A senha deve conter dígitos (0-9)',
  passwordErrorUpperCase: 'A senha deve conter no mínimo uma letra maiúscula (A-Z)',
  passwordErrorSpecialChar: 'A senha deve conter no mínimo um caracter especial (!@#)',
  passwordSuccessChanged: 'Senha alterada com sucesso.',
  passwordInvalid: 'Senha atual ou confirmação de senha inválidos.',
  passwordChange: 'Alterar senha',
  passwordChangeHeader: 'Para alterar a sua senha, digite a nova senha abaixo.',
  passwordInsert: 'Digite sua nova senha.',
  passwordIndicatorTitle: 'Política de Senha',
  passwordIndicatorSubTitle: 'A senha deverá conter',
  passwordIndicatorMinChar: 'No mínimo 9 caracteres',
  passwordIndicatorNumber: 'Dígitos (0-9)',
  passwordIndicatorUpperCase: 'Pelo menos uma letra maiúscula (A-Z)',
  passwordIndicatorSpecialChar: 'Pelo menos um caracter especial (!@#)',
  passwordIndicatorPasswordEqual: 'Senhas iguais',
  payWithBankSlip: 'Pagar com Boleto',
  paid: 'Pago',
  payment: 'Pagamento',
  paymentTerm: 'Faturar',
  paymentType: 'Forma de pagamento',
  paymentType2: 'Tipo de Pagamento:',
  paymentMade: 'Pagamento confirmado',
  personalData: 'Dados Pessoais',
  phone: 'Telefone:',
  phone2: 'Telefone',
  pisCofins: 'PIS/COFINS',
  pdf: 'PDF',
  purpose: 'Finalidade',
  product: 'Produto',
  products: 'Produtos',
  products2: 'Produto(s)',
  productType: 'Tipo de produto',
  productBought: 'produto(s) comprado(s)',
  productInformation: 'Informações do Produto',
  productsPromotion: 'Produtos em Promoção',
  productsSimilar: 'Produtos Similares',
  productGoInitialPage: 'Página Inicial',
  productInitialPage: 'Página Inicial',
  productGoProductsPage: 'Ir para Página de Produtos',
  productDatasheet: 'Ficha Técnica',
  productDatasheetAvailable: 'Materiais disponíveis',
  productDatasheetDetails: 'Dados técnicos do Fabricante',
  productRatings: 'Avaliações',
  productCartAdd: 'Adicionar na sacola',
  productStock: 'Estoque',
  productTotalStock: 'Total',
  productView: 'Visualizar',
  productToFavorite: 'Favoritar',
  productFavorite: 'Produtos Favoritos',
  productShare: 'Compartilhe este produto',
  productInPromotion: 'Produtos em promoção',
  productRecommended: 'Recomendado para você',
  productSearched: 'Produtos mais procurados',
  productsFounded: 'Produtos encontrados',
  productsFilter: 'Filtros',
  productsMinPrice: 'Menor preço',
  productsMaxPrice: 'Maior preço',
  productsRelevance: 'Relevância',
  productsInCategory: 'na categoria',
  productsToTerm: 'para o termo',
  master: 'Principal',
  zeroedStockMain: 'Caso o item esteja em outro estoque que não o seu principal, favor entrar em contato com o vendedor responsável pela sua conta.',
  province: 'Bairro',
  province2: 'Bairro:',
  price: 'Preço',
  price2: 'Preço:',
  privacyPolicy: 'Politica de privacidade',
  proEmprego: 'Pró-Emprego (Somente SC)',
  quantity: 'Qtd',
  quantity2: 'Qtd:',
  quality: 'Qualidade Garantida',
  qualityText: 'Trabalhamos somente com produtos das melhores marcas do mercado.',
  readToSend: 'Pedido pronto para envio',
  recoverPassword: 'Recuperar senha',
  recoverPasswordResponseMsg: 'Se o usuário for válido, será encaminhado por e-mail uma nova senha.',
  recoverPasswordHeader: 'Para recuperar a sua senha, digite o seu email abaixo.',
  registerSolicitation: 'Solicitação de Cadastro',
  remove: 'Remover',
  return: 'Voltar',
  returnHome: 'Voltar para Home',
  resale: 'Revenda',
  results: 'Resultados',
  resultsSearch: 'Resultados da busca',
  requestAccess: 'Solicitar Acesso',
  requestAccessText: 'Sua Empresa já possui cadastro? Solicite a liberação de seu acesso',
  requestLimit: 'Número máximo de tentativas atingido. Para sua segurança tente novamente em',
  report: 'Relatório',
  reports: 'Relatórios',
  search: 'Buscar',
  saveCardText: 'Salvar dados do cartão para futuras compras',
  searchProduct: 'O que você está precisando hoje?',
  searchTerm: 'Pesquisar por termo...',
  sector: 'Setor',
  selected: 'Selecionados',
  selectAddressToTake: 'Endereço para retirar:',
  selectAddressToSend: 'Endereço de envio:',
  selectDeliveryType: 'Selecione o tipo de entrega:',
  selectPaymentMethod: 'Selecione a forma de pagamento:',
  sellMultiple: 'Multiplo Venda:',
  sellMultipleNeeds: 'Quantidade deve ser multiplo de ',
  showing: 'Mostrando',
  showDetails: 'Ver detalhes',
  soneparCode: 'Código Sonepar:',
  nortelCode: 'Código Nortel:',
  st: 'ST',
  securityCode: 'Código de segurança:',
  securityCode2: 'Código de segurança',
  state: 'Estado',
  stateRegistration: 'Inscrição Estadual',
  street: 'Rua',
  spot: 'Spot',
  spotlight: 'Destaque',
  spotlightProducts: 'Produtos em Destaque!',
  subTotal: 'Subtotal',
  subCategories: 'Subcategorias',
  summary: 'Resumo',
  summaryList: 'Relatório',
  successBuy: 'Sua compra foi efetuada com sucesso',
  successNewRegister: 'Cadastro criado com sucesso!',
  successNewRegisterText: 'Seu cadastro já está liberado! Acesse a pagina de Login.',
  successNewRegisterTextTwo: 'Seu cadastro já está liberado!',
  successNewRegisterTextThree: 'Acesse a pagina de Login',
  successRegister: 'Acesso solicitado com sucesso!',
  successRegisterText: 'Enviaremos um e-mail assim que seu acesso estiver ativado.',
  successSolicitation: 'Solicitação enviada com sucesso',
  successSolicitationText: 'Enviaremos um e-mail assim que sua solicitação for aprovada.',
  storeTake: 'Retirar na loja',
  spotItemsError: 'Não é possível comprar mais itens do que a quantidade disponívl',
  of: 'de',
  orderMade: 'Pedido realizado',
  orderDetail: 'Detalhes do pedido',
  orderCodeOptional: 'Código Ordem Cliente (Opcional)',
  orderMadeBy: 'Pedido realizado por: ',
  orderSolicitedBy: 'Pedido solicitado por: ',
  take: 'Retirar:',
  taxBenefits: 'Benefícios Fiscais',
  thanks: 'Obrigado',
  timeDelivered: 'Tempo de entrega',
  toBuy: 'para finalizar a compra',
  total: 'Total',
  total2: 'Total:',
  totalCartDetails: '(Valor + %{tax})',
  totalValue: 'Valor Total',
  transportCompany: 'Transportadora',
  transportDocument: 'Transportadora CNPJ',
  unmarkAll: 'Desmarcar Todos',
  undefined: 'Indefinido',
  userBlocked: 'Usuário está bloqueado.',
  userHasNoActiveContract: 'Usuário inativo',
  userNotFound: 'Usuário não encontrado.',
  userInvalidPassword: 'Senha inválida.',
  userInvalidPasswordPolicy: 'Sua senha não segue a política de senha, um e-mail será enviado com a nova senha',
  userInvalid: 'Usuário ou senha inválida.',
  userTerms: 'Termos de uso',
  cookies: 'Uso dos Cookies',
  unityPrefix: 'Un:',
  unityCustomerPrefix: 'Un Cliente:',
  unavailable: 'INDISPONÍVEL',
  visualizeCart: 'Ver Carrinho',
  visualizeDetail: 'Ver Detalhes',
  xml: 'XML',
  welcome: 'Bem-vindo(a)',
  withOutContract: 'Sem Contrato',
  withoutStock: 'Sem estoque',
  wishToCopyOrder: 'Deseja realmente copiar o pedido?',
  wishToApproveCart: 'Deseja realmente ver o carrinho?',
  wishToDeleteCard: 'Deseja realmente excluir o Cartão de',
  workingDays: 'dias úteis',
  xpedTooltipText: 'Insira o número de sua ordem de compra. Este dado será exibido no xPed da Nota Fiscal. '
    + ' O campo é limitado a 10 caracteres sendo permitido apenas letras,'
    + ' números, hífen (-), underline(_), vírgula (,) e barra (/\\).”',
  awaitingApproval: 'Aguardando aprovação',
  disapproved: 'Reprovado',
  awaitingNf: 'Aguardando NF',
  totalBilled: 'Faturado Total',
  parcialBilled: 'Faturado Parcial',
  filterBy: 'Filtrar por:',
  filterByContract: 'Filtrar por Contrato:',
  filterByStatus: 'Filtrar por Status:',
  attention: 'Atenção',
  selectDefaultAddress: 'Deseja configurar o endereço escolhido como padrão?',
  yes: 'Sim',
  no: 'Não',
  invalidItemsCart: 'Não é possível finalizar a compra pois há itens no carrinho sem estoque.',
  cantAddToCart: 'Não é possivel adicionar este item no carrinho, pois não tem estoque',
  picking: 'Em Separação',
  deliveredToCarrier: 'Entregue a Transportadora',
  outForDelivery: 'Saiu para Entrega',
  outForDeliveryPrev: 'Prev:',
  availableCustumer: 'Disponível Retirada',
  done: 'Efetuado',
  errorPurchaseContact: 'Erro no pagamento, entrar em contato com a administração da loja.',
  errorInvalidDoc: 'Documento inválido, favor validar CNPJ/CPF informado.',
  errorMinimumPrice: 'O carrinho não pode ser menor que {?}',
  errorInvalidCard: 'Dados do cartão inválido, favor validar novamente.',
  errorLocation: 'Endereço não localizado.',
  errorLocationOrClient: 'Endereço ou Cliente não localizado.',
  errorForbidden: 'Não foi possível finalizar a compra. Por favor entre em contato com o administrador de seu contrato/conta.',
  errorMaxObservation: 'O campo de observação não pode ultrapassar {?} caracteres.',
  errorGkoClientNotFound: 'Endereço não localizado, favor entrar em contato com a administração da loja.',
  errorPurchaseNotFinished: 'Erro no pagamento, entrar em contato com a admistração da loja.',
  errorPsGetSessionId: 'Falha ao obter id da sessão, favor entrar em contato com a administração da loja.',
  errorPsSetSessionId: 'Falha ao atribuir id da sessão, favor entrar em contato com a administração da loja.',
  errorPsSetHashSessionId: 'Falha ao atribuir hash da sessão, favor entrar em contato com a administração da loja.',
  errorPsGetBrand: 'Número do cartão inválido ou não localizado, favor entrar em contato com a administração da loja.',
  errorPsCreateCardToken: 'Falha ao gerar token do cartão, favor entrar em contato com a administração da loja.',
  errorNotFoundDoc: 'CNPJ/CPF do cliente não localizado, favor entrar em contato com a administração da loja.',
  dates: 'Datas',
  date: 'Data',
  responsibles: 'Responsáveis',
  status: 'Status',
  approver: 'Aprovador',
  request: 'Requisição',
  requester: 'Requisitante',
  open: 'Aberto',
  cartNumber: 'Número Carrinho',
  reasonCancelOrder: 'Motivo do Cancelamento',
  billetWarningMessage: 'Seu pedido será faturado em até 48 horas após confirmação do pagamento do boleto.',
  successBuyBillet: 'Seu pedido foi efetuado com sucesso. Para finalizar a compra efetue o pagamento do boleto até a data do vencimento.',
  checkoutGenerateTicket: 'Finalizar pedido e Gerar boleto',
  col: 'Coluna',
  list: 'Lista',
  stateRegistrationNotice: 'Em Caso de IE e condição de não contribuinte de ICMS, favor entrar em contato após finalização do cadastro',
  noticeResaleOption: 'Finalidade revenda é obrigatório o preenchimento da inscrição estadual',
  errorDateReported: 'A data informada não pode maior que a atual',
  incompletePhoneError: 'Número de telefone informado incompleto',
  birthError: 'Informe uma data de nascimento válida',
  phoneError: 'Informe um número de telefone válido',
  birthError2: 'Data de nascimento do cliente não localizado, favor entrar em contato com a administração da loja.',
  phoneError2: 'Telefone do cliente não localizado, favor entrar em contato com a administração da loja.',
  noticeMaximumContractValue1: 'O Contrato',
  noticeMaximumContractValue2: 'ultrapassou o valor máximo de',
  noticeMaximumContractValue3: 'por favor revisar os itens desse contrato para adequação do valor máximo.',
  noticeMaximumValueContracts1: 'Os Contratos',
  noticeMaximumValueContracts2: 'ultrapassam os valores máximos de',
  noticeMaximumValueContracts3: 'por favor revisar os itens desses contratos para adequação dos valor máximos.',
  erroMaximumContractValue: 'Valor do contrato não informado, favor entrar em contato com a administração da loja.',
  cartHistory: 'Histórico do Carrinho',
  approvalDate: 'Data de aprovação',
  requestDate: 'Data do Pedido',
  purchaseOrder: 'Ordem de Compra:',
  null: 'Nulo',
  duplicatedCartItems: 'O carrinho possui produtos duplicados',
  instructionsImportingProductList: 'Instruções para importar lista de produtos',
  selectFile: 'Selecione um arquivo',
  importListInstruction1: 'Baixe o modelo de importação.',
  importListInstruction2: 'Baixar modelo de planilha',
  importListInstruction3: 'Inserir os produtos e suas quantidades no documento de importação.',
  importListInstruction4: 'Inserir os produtos desejados, salvar a planilha no (formato XLS) e envie da área abaixo.',
  importListInstruction5: 'Enviar planilha',
  cartImportUploadWaitMessage: 'Por favor, aguarde alguns segundos enquanto o upload é feito',
  importList: 'Importar Lista',
  line: 'linha',
  dragAndDropCartErrorTitle: 'Os seguintes erros foram encontrados',
  noAggregatedProductsToCart: 'Contém %{0} produtos no carrinho',
  goToCartNow: 'Ir para o carrinho',
  UploadedEmpty: 'Arquivo enviado está vazio',
  LGPDCookiesMessage: 'Este site usa cookies e dados pessoais de acordo com os nossos Termos de Uso e Política de Privacidade, ao continuar navegando nesse site, você se declara estar ciente dessas condições.',
  Proceed: 'Prosseguir',
  empty: 'Vazio',
  imageIllustrative: 'Imagem meramente ilustrativa',
  pickUpAtLockerStore: 'Retirar na loja | OPÇÃO LOCKER',
  minimumBillingDate: 'Programe sua Compra',
  billingDateTooltip: 'Programe a sua compra. Ao colocar uma data futura, a nota fiscal referente ao seu pedido será emitida apenas a partir desta data. É valido para entregas totais ou parciais.',
  billingDateInformation: 'A data acima somente é valida para a condição de pagamento de FATURAMENTO',
  invalidMinimumBillingDate: 'Não é possível finalizar a compra, pois a data mínima de faturamento é inválida.',
  errorMinimumBillingDate: 'Não é possível finalizar a compra, pois foi informado data mínima de faturamento para forma de pagamento diferente de FATURAMENTO',
  errorMinorMinimumBillingDate: 'A data selecionada é menor que a data atual',
  bidSizeInformative: 'Exemplo:  Você  está  comprando  1.000  metros,  mas  gostaria  de  receber  em  dois lances de 500m, então, no campo tamanho do lance preencha 500m.',
  bidSize: 'Tamanho do Lance',
  bidSize2: 'Tamanho do Lance:',
  BidAvailable: 'Lance Disponíveis',
  reportProblem: 'Reporte um Problema',
  websiteReview: 'O que você acha do nosso site',
  reasonForFeedback: 'Tenho um comentário sobre',
  feedback: 'O que você quer compartilhar conosco',
  submit: 'Enviar',
  productFeedbackNotice: 'Para fazer o envio preencha todos os campos acima',
  selectAnOption: 'Selecione uma opção',
  freightDays1: 'Receba em até',
  freightDays2: 'dia(s) útil(eis) após a confirmação do pagamento ou confirmação do seu pedido de compra.',
  purchaseFeedbackRating: 'Como você avalia sua experiência de compra ?',
  cancelFeedBackButton: 'Agora não...',
  purchaseFeedbackRatingWarning: 'Para enviar seu feedback sobre a compra é necessário dar uma nota',
  purchaseFeedbackOpinionTextWarning: 'Para enivar seu feedback sobre a compra é necessário preencher o texto acima',
  unit: 'Unidade',
  requiredEmail: 'É obrigatório informar o e-mail',
  requiredName: 'É obrigatório informar o nome',
  requiredPhone: 'É obrigatório informar o número de telefone',
  requiredUnit: 'É obrigatório informar a unidade',
  requiredField: 'Campo obrigatório',
  managerEmail: 'E-mail do gestor',
  invalidManagerEmail: 'E-mail do gestor inválido',
  ProductsInCartWithInvalidMultipleQuantities: 'Produtos no carrinho com quantidade múltipla inválida',
  downloadXML: 'Baixar XML',
  downloadPDF: 'Baixar PDF',
  requiredDeliveryAddress: 'É obrigatório selecionar uma opção de entrega',
  invoiceDevolutions: 'Devoluções',
  pending: 'Pendentes',
  accepted: 'Aceitas',
  recused: 'Recusadas',
  finished: 'Finalizadas',
  cancelled: 'Canceladas',
  devolutionSolicitation: 'Solicitação de Devolução',
  newDevolutionSolicitation: 'Nova Solicitação de Devolução',
  salesInvoice: 'Nota fiscal de venda',
  productCode: 'Código',
  salesInvoiceProducts: 'Produtos da Nota Fiscal de Venda',
  qtyToReturn: 'Quantidade a devolver',
  quantityReturned: 'Quantidade devolvida',
  totalQuantity: 'Quantidade total',
  returnInformation: 'Informações da Devolução',
  openRequest: 'Abrir Solicitação',
  reason: 'Motivo',
  detailedDescription: 'Descrição detalhada',
  freight: 'Frete',
  returnType: 'Tipo de devolução',
  hasReturnLetter: 'Possui carta de devolução',
  contactEmail: 'E-mail do contato',
  attachment: 'Anexo',
  uploadFile: 'Carregar arquivo',
  salesInvoiceNotFound: 'Nota fiscal de venda não encontrada',
  unknownErrorTryingToFindInvoice: 'Erro desconhecido ao tentar localizar essa nota fiscal',
  noFileSelectedForSubmission: 'Não foi selecionado nenhum arquivo para envio',
  unknownErrorWhenSavingFile: 'Erro desconhecido ao salvar o arquivo',
  mandatoryFillSalesInvoiceNumber: 'Obrigatório preencher o número da nota fiscal de venda',
  productNeedToOpenReturnRequest: 'Pelo menos 1 produto precisa ser devolvido para abrir a solicitação de devolução',
  mandatoryToFillReasonToOpenReturnRequest: 'Obrigatório preencher o motivo para abrir a solicitação de devolução',
  mandatoryDescriptionToOpenReturnRequest: 'Obrigatório informar uma descrição para abrir a solicitação de devolução',
  mandatoryFreightTypeToOpenReturnRequest: 'Obrigatório informar o tipo do frete para abrir a solicitação de devolução',
  mandatoryReturnTypeToOpenReturnRequest: 'Obrigatório informar qual será o tipo da devolução para abrir a solicitação de devolução',
  mandatoryReturnLetterToOpenReturnRequest: 'Obrigatório informar se existe carta de devolução para abrir a solicitação de devolução',
  requiredSelectContactEmailsToOpenReturnRequest: 'Obrigatório selecionar os e-mails de contato para abrir a solicitação de devolução',
  unknownErrorWhenOpeningReturnRequest: 'Erro desconhecido ao abrir a solicitação de devolução',
  returnRequestOpenSuccessfully: 'A solicitação de devolução foi aberta com sucesso',
  noReturnDevolutionSolicitationMade: 'Nenhuma solicitação de devolução encontrada',
  requestInvoiceDevolution: 'Solicitar devolução',
  invoiceDevolutionValue: 'Valor da nota de devolução: ',
  invoiceDevolutionNumber: 'Número da nota de devolução: ',
  nciCode: 'Código da NCI: ',
  dateOfDevolution: 'Data da devolução: ',
  requestingUser: 'Usuário solicitante: ',
  invoiceDevolutionPending: 'Pendente',
  invoiceDevolutionAccepted: 'Aceita',
  invoiceDevolutionRecused: 'Recusada',
  invoiceDevolutionFinished: 'Finalizada',
  invoiceDevolutionCancelled: 'Cancelada',
  NCIDetails: 'Detalhes da solicitação de devolução',
  invoiceDevolutionReasonForOpening: 'Motivo da abertura: ',
  invoiceDevolutionProductCode: 'Código do produto: ',
  invoiceDevolutionQuantity: 'Quantidade: ',
  invoiceDevolutionPrice: 'Preço: ',
  cancelInvoiceDevolution: 'Cancelar Devolução',
  cancelInvoiceDevolutionWarning: 'A solicitação de devolução %{0} será cancelada...',
  cancelInvoiceDevolutionWarning2: 'Não será possível reverter essa ação, realmente deseja fazer isso ?',
  invoiceDevolutionCancelledSuccessfully: 'Solicitação de devolução cancelada com sucesso',
  notShowNCIDetails: 'Não foi possível mostrar os detalhes dessa solicitação de devolução',
  openSolicitation: 'Solicitação aberta',
  pendingSolicitation: 'Solicitação pendente',
  approvedSolicitation: 'Solicitação aprovada',
  finalizedSolicitation: 'Solicitação finalizada',
  rejectSolicitation: 'Solicitação recusada',
  cancelledSolicitation: 'Solicitação cancelada',
  cifSolicitation: 'Por conta do cliente',
  fobSolicitation: 'Por conta da Nortel',
  sphereRejectSolicitation: 'Sphere recusou a abertura dessa solicitação de devolução...',
  invoiceNotRelatedToCustomer: 'Essa nota fiscal de venda não está relacionada com este cliente.',
  salesInvoiceOnlyAcceptsNumbers: 'Nota fiscal de venda somente aceita números.',
  salesInvoiceNumberNotFound: 'Número da nota fiscal de venda não encontrado.',
  clientCodeNotFound: 'Código do cliente não encontrado.',
  notPossibleToCancelThisSolicitation: 'Não foi possível realizar o cancelamento dessa solicitação de devolução...',
  selectClientContacts: 'Selecione o(s) contato(s)',
  NCINumberNotFound: 'Código NCI não informado.',
  responsibleForReceiving: 'Responsável recebimento',
  deliverySector: 'Setor de entrega',
  invalidResponsibleReceiving: 'Obrigatório informar o(a) responsável pelo recebimento',
  invalidDeliverySector: 'Obrigatório informar o setor de entrega',
  quantityDoesNotSuitMe: 'Essa quantidade não me atende',
  quantityWishBuy: 'Digite a quantidade que deseja comprar:',
  okButton: 'OK',
  leadTimeNotFound: 'Não foi possível encontrar o LeadTime desse produto, tente novamente mais tarde...',
  sampleNumber: 'Ex: 50.73',
  requiredQuantity: 'Obrigatório informar a quantidade',
  reportedQuantityGreaterTotalStock: 'A quantidade informada deve ser maior que o estoque total disponível',
  displayProducts: 'Exibir',
  quantityAvailable: 'Quantidade disponível em:',
  requestUserName: 'Nome do requisitante',
  requestUserEmail: 'E-mail do requisitante',
  requestUserInformation: 'Informações do requisitante',
  invalidPunchoutUserAccess1: 'O usuário "%{0}" não pertence a uma conta Punchout para realizar compra, apenas para consulta do catálogo.',
  invalidPunchoutUserAccess2: 'Como o usuário "%{0}" pertence a uma conta Punchout, é necessário efetuar o login através de uma seção Punchout para realizar a compra.',
  invalidPunchoutUserAccess3: 'Por gentileza, contate o administrador EDI do Time Digital-Nortel.',
  userHasNoPriceContract: 'Aprovador não tem acesso ao contrato de preço do carrinho selecionado',
  userHasNoPriceSpotPermission: 'Aprovador não tem acesso ao preço de spot do carrinho selecionado',
  purchaseClosedForPayment: 'Erro na conclusão do pedido, carrinho já finalizado.',
  purchaseInterruptedForPayment: 'Erro ao concluir o pedido, sem permissão para concluir a compra.',
  productsWrongPrince: 'Erro ao concluir o pedido, preço do(s) produto(s) %{0}  incorreto(s).',
  divergenceInProducts: 'Divergência na quantidade de produtos no carrinho.',
  hello: 'Olá',
  identify: 'Identifique-se aqui',
  addToCart: 'Adicionar ao carrinho',
  addAllToCart: 'Adicionar tudo ao carrinho',
  backToPreviousProduct: 'Voltar ao produto anterior',
  deliveryInEveryBrazilianState: 'Entrega em todo Brasil',
  globalServiceStructure: 'Temos a estrutura necessária para atendê-lo da melhor forma, onde quer que esteja.',
  guaranteeQuality: 'Garantia de Qualidade',
  bestProductsOfBestBrands: 'Trabalhamos somente com produtos das melhores marcas do mercado.',
  afterSalesSupport: 'Nosso serviço pós-venda está sempre disponível para responder a quaisquer perguntas que você possa ter sobre seu pedido.',
  seeTheEntireProductPortfolio: 'Veja todo o portfólio de produtos',
  greenPortfolio: 'Portfólio Verde',
  productsWithProblem: 'Produtos com Problemas, favor entrar em contato com o administrador.',
  downloadInvoice: 'Baixar DANFE',
  withoutInvoice: 'Nenhuma Nota Fiscal gerada até o momento',
};
